__turbopack_context__.v({
  "content": "CreditsWeb-module-scss-module__UjpJXW__content",
  "imageRoot": "CreditsWeb-module-scss-module__UjpJXW__imageRoot",
  "section": "CreditsWeb-module-scss-module__UjpJXW__section",
  "titlePrimary": "CreditsWeb-module-scss-module__UjpJXW__titlePrimary",
  "titleSecondary": "CreditsWeb-module-scss-module__UjpJXW__titleSecondary",
  "titleTertiary": "CreditsWeb-module-scss-module__UjpJXW__titleTertiary",
});
